import React from 'react'
import { IInputValue } from '../../../types/templates'
import { Text, View, Font } from '@react-pdf/renderer'
import { IService, SERVICE_STATUS } from '../../../types/services'
// import { uid } from 'uid'

// const BORDER_COLOR = '#000000'
// const BORDER_STYLE = 'solid'
/* const styles = StyleSheet.create({
   title: {
     fontSize: 16,
     textAlign: 'center',
     textTransform: 'uppercase',
     marginBottom: 15,
     fontFamily: 'OpenSans',
     fontStyle: 'bold',
   },
   subtitle: {
     fontSize: 14,
     margin: 12,
     textDecoration: 'underline',
     marginBottom: 15,
     fontFamily: 'OpenSans',
     fontStyle: 'semi-bold',
   },
   text: {
     margin: 12,
     fontSize: 12,
     fontFamily: 'OpenSans',
     textAlign: 'justify',
   },
   image: {
     height: 150,
     marginBottom: 30,
     marginHorizontal: 100,
   },
   table: {
     display: 'table',
     width: 'auto',
     margin: 12,
     borderStyle: BORDER_STYLE,
     borderColor: BORDER_COLOR,
     borderWidth: 0,
     borderRightWidth: 0,
     borderBottomWidth: 0,
   },
   tableRow: {
     margin: 'auto',
     flexDirection: 'row',
     textAlign: 'center',
     borderRightWidth: 1,
     borderBottomWidth: 1,
   },
   tableCol: {
     borderStyle: BORDER_STYLE,
     borderColor: BORDER_COLOR,
     borderWidth: 0,
     borderLeftWidth: 1,
     borderTopWidth: 1,
   },
   tableCell: {
     margin: 2,
     fontSize: 12,
     fontFamily: 'OpenSans',
   },
 }) */

// Define fonts for the component
Font.register({
  family: 'OpenSans',
  fonts: [
    {
      src: require('../fonts/OpenSans-Regular.ttf').default,
    },
    {
      fontStyle: 'semi-bold',
      src: require('../fonts/OpenSans-SemiBold.ttf').default,
    },
    {
      fontStyle: 'bold',
      src: require('../fonts/OpenSans-Bold.ttf').default,
    },
  ],
})

// Define fonts for the component
Font.register({
  family: 'DancingScript',
  fonts: [
    {
      src: require('../fonts/Signature/DancingScript-Regular.ttf').default,
    },
    {
      fontStyle: 'semi-bold',
      src: require('../fonts/Signature/DancingScript-Medium.ttf').default,
    },
    {
      fontStyle: 'bold',
      src: require('../fonts/Signature/DancingScript-Bold.ttf').default,
    },
  ],
})

// const Subtitle = ({ children, ...props }: any) => (
//   <Text style={styles.subtitle} {...props}>
//     {children}
//   </Text>
// )

/**
 * Custom `NodeItem` component declaration.
 * This component is used to define styles and replace elements of pdf
 * @param {Any} PDFNode
 * @param {Array} inputValues
 * @return NodeItem
*/
const NodeItem = ({
  PDFNode,
  service
}: {
  PDFNode: any
  inputValues: IInputValue[]
  service: IService | undefined
}): JSX.Element => {
  const parseStyles = (styles: string) => {
    return styles
      .split(';')
      .filter((style) => style.split(':')[0] && style.split(':')[1])
      .map((style) => [
        style
          .split(':')[0]
          .trim()
          .replace(/-./g, (c) => c.substr(1).toUpperCase())
          .replace('Cambria, serif', 'OpenSans'),
        style.split(':')[1].trim(),
      ])
      .reduce(
        (styleObj, style) => ({
          ...styleObj,
          [style[0]]: style[1],
        }),
        {}
      )
  }

  /* const getText = (nodes: any): any => {
     if (nodes.length === 1) return createReactElement(nodes[0])
     else {
       let text = ''
       for (let index = 0; index < nodes.length; index++) {
         let node = nodes[index]
         if (node.nodeName === 'BR') text += '\n'
         if (node.childNodes && node.childNodes.length > 0 ) {
           while (node.childNodes && node.childNodes.length > 0) {
             console.log(node.childNodes);
             node = node.childNodes
             console.log('with child');
             console.log(node);
             if (node.nodeValue) {
               text += node.nodeValue
             }
           }
         } else {
           console.log('NO CHILDS', node.nodeName, node.nodeValue)
         }
       }
       return <Text>{text}</Text>
     }
   } */

  /**
   * Custom `createReactElement` component declaration.
   * This component is used to define styles and replace elements of pdf
   * @param {Any} node
   * @return createReactElement
  */
  const createReactElement = (node: any) => {
    if (node.hasChildNodes()) {
      const childs: any = [...node.childNodes]
      const style: any = parseStyles(node.style.cssText)
      const { textAlign, fontWeight } = style
      const element: any = ['STRONG', 'SPAN', 'P',].includes(node.nodeName)
        ? Text
        : View

      if(element === 'TEXT' && node.className === '__se__t-shadow' && ( !service || service && service.service_status_id === SERVICE_STATUS.PAYMENT_ON_HOLD ))
      {
        const Element = React.createElement(
          element,
          {
            style: {
              color: "#f4f4f4",
              backgroundColor: '#f4f4f4', 
              textDecoration: 'line-through'
            },
          },
          childs.map((child: any) => createReactElement(child))
        )
        return Element
      }

      if(element === 'TEXT' && node.nodeName === 'P' && node.childNodes[0].nodeName === 'BR')
      {
        const Element = React.createElement(
          element,
          {
            style: { marginBottom: '4', marginTop: '6' }
          },
          childs.map((child: any) => createReactElement(child))
        )
        return Element
      }
       
      try {
        const Element = React.createElement(
          element,
          {
            style: {
              fontFamily: 'OpenSans',
              fontStyle:
                node.nodeName === 'STRONG' || fontWeight ? 'bold' : undefined,
              fontSize: '12pt',
              // fontSize:
              //   !fontSize || ['', ' '].includes(fontSize)
              //     ? undefined
              //     : fontSize.replace('px', 'pt'),
              textAlign:
                !textAlign || ['', ' '].includes(textAlign)
                  ? undefined
                  : textAlign,
              textDecoration: node.nodeName === 'U' ? 'underline' : undefined,
              //marginTop: '2px',
              // flexDirection: 'row',
              marginBottom: '0.5vh',
            },
            // key: uid()
          },
          childs.map((child: any) => createReactElement(child))
        )
        return Element
      } catch (error) {
        return <></>
      }
    } else {
      if (
        node.nodeValue &&
        node.nodeName === '#text' &&
        !['', ' '].includes(node.nodeValue)
      ) {
        if (node.nodeValue.includes('*sign*')) {
          const text = node.nodeValue
            .replace('*sign*', '')
            .replace(/\s\s+/g, ' ')
            .replaceAll(' ,', ',')
            .replaceAll(' .', '.')
            .replace(/,,+/g, ',')
          return (
            <Text
              style={{
                width: `${
                  text.length < 10 ? '100pt': text.length * 7.5
                }pt`,
              }}
            >
              <Text
                style={{
                  fontFamily: 'DancingScript',
                  fontSize: '16pt',
                  textAlign: 'left',
                }}
              >
                {text}
              </Text>
              <Text
                style={{
                  display: 'flex',
                  // borderBottom: '1px solid black',
                  // paddingBottom: '2px',
                  marginBottom: '2px',
                  padding: '1px',
                  backgroundColor: 'back',
                }}
              ></Text>
            </Text>
          )
        }
        return (
          <Text>
            {node.nodeValue
              .replace(/\s\s+/g, ' ')
              .replaceAll(' ,', ',')
              .replaceAll(' .', '.')
              .replace(/,,+/g, ',')}
          </Text>
        )
      } else {
        if (node.nodeName === 'BR') {
          return React.createElement(View, {
            // key: uid()
            style: { marginTop: '1vh' },
          })
        }
        return <></>
      }
    }
  }

  try {
    return createReactElement(PDFNode)
  } catch (error) {
    return <></>
  }
}

export default NodeItem